
import { SidebarLayout } from "./SidebarLayout";

export function AppLayout({ children }: { children: React.ReactNode }) {
  return <SidebarLayout>{children}</SidebarLayout>;
}
